<template>
    <div class="invite">
        <nav-bar></nav-bar>
        <div :class="isMobile ? 'm-content' : 'content'">
            <div class="box">
                <img src="../../assets/img/invite.png" />
                <p class="title">{{ $t('个人资料邀请码') }}</p>
                <p class="code">{{ info.invite_code }}</p>
                <div class="copy" v-clipboard:copy="invite" v-clipboard:success="onSuccess">{{ $t('复制') }}</div>
            </div>
        </div>
        <footers v-if="!isMobile"></footers>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import { info } from '../../api/index'
    export default {
        data() {
            return{
                invite: '',
                info: {}
            }
        },
        computed: {
            ...mapGetters("device", ["isMobile"]),
        },
        created() {
            this.getInfo()
        },
        methods: {
            getInfo() {
                info().then(res=> {
                    if (res.code == 0) {
                        this.info = res.data.info
                        this.invite = 'https://' + window.location.hostname + '/#/login?code=' + this.info.invite_code
                    }
                })
            },
            // 复制邀请码
            onSuccess() {
                this.$message({
                    message: this.$t('复制成功'),
                    type: 'success'
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
.invite {

    .content {
        background: #f8f8f8;
        background-image: linear-gradient(-225deg, #2cd8d5, #c5c1ff 56%, #ffbac3);
        background-position: 0;
        background-size: cover;
        display: flex;
        justify-content: center;
        min-height: 100vh;
        width: 100%;

        .box {
            width: 38%;
            margin: 20px auto;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;

            img {
                width: 260px;
                height: 260px;
                margin-top: 80px;
            }

            .title {
                margin: 0 0 40px 0;
                color: #5a5a5a;
                font-size: 18px;
            }

            .code {
                font-size: 27px;
                font-weight: 600;
            }

            .copy {
                width: 38%;
                text-align: center;
                background-color: rgb(236, 174, 56);
                color: #fff;
                border-radius: 24px;
                padding: 10px 0;
                font-size: 14px;
                cursor: pointer;
            }
        }
    }

    .m-content {

        .box {
            background-color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 10px;

            img {
                width: 200px;
                height: 200px;
                margin-top: 80px;
            }

            .title {
                margin: 0;
                color: #5a5a5a;
                font-size: 14px;
            }

            .code {
                font-size: 16px;
                font-weight: 600;
            }

            .copy {
                width: 85%;
                text-align: center;
                background-color: rgb(236, 174, 56);
                color: #fff;
                border-radius: 24px;
                padding: 10px 0;
                font-size: 14px;
                cursor: pointer;
            }
        }
    }
}
</style>